module.exports = __webpack_public_path__ + "img/login.0810d0fc.png";